import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const RightArrowIcon = ({ className, color = Color.White }: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 6 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.367119 1.27669C0.0750588 0.984628 0.0750581 0.511105 0.367118 0.219045C0.659178 -0.0730151 1.1327 -0.0730149 1.42476 0.219045L4.95082 3.7451C5.24288 4.03716 5.24288 4.51069 4.95082 4.80275C4.65876 5.09481 4.18524 5.09481 3.89318 4.80275L0.367119 1.27669Z"
      fill={color}
    />
    <path
      d="M1.22956 8.52402C0.948281 8.8053 0.492238 8.8053 0.210959 8.52403C-0.0703196 8.24275 -0.0703197 7.7867 0.210959 7.50542L3.95175 3.76464C4.23303 3.48336 4.68907 3.48336 4.97035 3.76463C5.25163 4.04591 5.25163 4.50196 4.97035 4.78324L1.22956 8.52402Z"
      fill={color}
    />
  </svg>
);
